import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {updateComparison_template} from "../components/templates/updateComparison_template";

declare var ko: any;
declare var page: any;

export class updateComparison extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected updateComparison_template: updateComparison_template;


    //
    // implementation of base class [vnModule]
    protected getModuleName(): string {

        return "updateComparison";
    }

    //
    // implementation of base class [vnModule]
    buildContent(): Array<Element> {

        this.updateComparison_template = new updateComparison_template("updateComparison", this.viewModel, this);
        this.template = this.updateComparison_template;

        return [this.updateComparison_template.build()];
    }

    public fillPage() : void{

        this.updateComparison_template.buildDatePickerCalendar();

        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData(): void{

        //this.loadingIn(this.updateComparison_template.builtTemplate.children.namedItem("list-results"));
        this.updateComparison_template.activateLoading();

        let usrReq_url: string = '/api/updatePerformance/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                obj.updateComparison_template.validationsList.clearMessages();
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getGraphData();
            });
        }
    }

    protected updateFilters(responseParsed: any){

        this.updateComparison_template.setUserBrands(responseParsed.brands);
        this.updateComparison_template.setBrandFilterItems(responseParsed.departments);
        this.updateComparison_template.setPostInitiativesFilterItems(responseParsed.postInitiatives);
        this.updateComparison_template.setPostIntentsFilterItems(responseParsed.postIntents);
        this.updateComparison_template.setPostContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.updateComparison_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
        this.updateComparison_template.setDataRangesItems();
    }

    protected getArticlesSuggestion(keyword) {

        let subViewModel = {
            filters: {keyword: keyword, brands: this.viewModel.updateComparison.userBrands}};
        let usrReq_url: string = '/api/emakiArticleSuggestions/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {


        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data) {
                    obj.updateComparison_template.setArticles(responseParsed.data);
                }
            });

            obj.updateComparison_template.deactivateLoading();
        }

    }

    public getGraphData(): void{

        this.updateComparison_template.activateGraphLoading();

        let subViewModel = this.updateComparison_template.getViewModelForRequest();
        let baseApiUrl = '/api/updatePerformance/get/graph_data';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getGraphData');
    }

    protected onDataRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                obj.updateComparison_template.resetSelectedRows();
                obj.updateComparison_template.updateGraphData(responseParsed);
                obj.updateComparison_template.setFinancialPermissions(responseParsed.isFinancialDataAccessible);
                obj.updateComparison_template.deactivateGraphLoading();
                obj.updateArticlesList();

            });
        }
    }

    public updateArticlesList(): void{

        this.updateComparison_template.activateLoading();
        this.updateComparison_template.hideExportButton();

        this.XHRHdl.cancelAndReset();

        let subViewModel = this.updateComparison_template.getViewModelForRequest();

        let usrReq_url: string = '/api/updatePerformance/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUpdatedArticlesReturn;
        this.XHRHdl.execute();
    }

    protected onGetUpdatedArticlesReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                obj.setUpdatedArticles(responseParsed.data);
                obj.setPageNumber(responseParsed.currentPage);
                obj.setPagination(responseParsed.totalCount);
                obj.setResultInfo(responseParsed.totalCount, responseParsed.totalPage);
            });

            obj.updateComparison_template.deactivateLoading();
        }
    }
    protected setUpdatedArticles(updatedArticles): void {
        this.updateComparison_template.setUpdatedArticles(updatedArticles);
    }

    protected setPageNumber(currentPage): void {
        this.updateComparison_template.setPageNumber(currentPage);
    }

    protected setPagination(totalCount): void {
        this.updateComparison_template.setPagination(totalCount);
    }
    protected setResultInfo(totalCount, totalPage){
        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.updateComparison_template.setResultPage(totalCount, totalPage, execTime);
    }

    public reorderUpdatedPages(): void {
        this.updateArticlesList();
    }

    protected filterMultipleSelectorOnChange(){
        this.getGraphData();
    }

    protected filterSimpleOnChange() {
        this.getGraphData();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterDateOnChange(){
        this.getGraphData();
    }

    public paginationOnPageClick(): void {
        this.updateArticlesList();
    }

    public getArticlesListForCSV(): void{

        this.updateComparison_template.activateLoading();

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.updateComparison_template.getViewModelForRequest();

        let usrReq_url: string = '/api/updatePerformance/csv';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onCSVDataRequestReturn;
        this.XHRHdl.execute();

    }

    protected onCSVDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateComparison_template.setCsvExportData(responseParsed);
                obj.updateComparison_template.exportCsvData();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.updateComparison_template.deactivateLoading();
            }
        };
    }


}


// WEBPACK FOOTER //
// ./js/modules/updateComparison.ts